import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import type { AcknowledgmentCommitmentItem } from 'partner360/features/acknowledgmentStatusDialog'

import { selectCockpitCommitmentData } from '../../../../model/selectors'

/**
 * The plan's signer rows from the cockpit's own `CommitmentData`, once they carry `SignoffPending`.
 * Without the field the payload cannot say whom the plan waits for, so `undefined` tells the step
 * to read the rows itself.
 */
export const useCockpitPlanSignerRows = (
  partnerId: string,
  offering: string | null
): AcknowledgmentCommitmentItem[] | undefined => {
  const commitments = useSelector(selectCockpitCommitmentData)

  return useMemo(() => {
    if (!offering) {
      return undefined
    }

    const rows = commitments.filter(
      (item) => item.PartnerId.trim() === partnerId.trim() && item.ProgramType === offering
    )

    return rows.length > 0 && rows.every((item) => 'SignoffPending' in item)
      ? (rows as unknown as AcknowledgmentCommitmentItem[])
      : undefined
  }, [commitments, offering, partnerId])
}
